import React from "react";
import { MessagesSquare } from "lucide-react";

/** Brand mark for "Futuro Chat" — teal→cyan gradient tile + wordmark. */
export function FuturoChatIcon({ size = 20, className = "" }) {
  return (
    <span
      className={`inline-flex items-center justify-center rounded-lg bg-gradient-to-br from-teal-500 via-cyan-500 to-sky-600 text-white shadow-sm shadow-cyan-500/30 ${className}`}
      style={{ width: size + 8, height: size + 8 }}
      aria-hidden="true"
    >
      <MessagesSquare style={{ width: size * 0.7, height: size * 0.7 }} />
    </span>
  );
}

export function FuturoChatWordmark({ className = "", testid }) {
  return (
    <span data-testid={testid} className={`font-bold tracking-tight bg-gradient-to-r from-teal-600 via-cyan-600 to-sky-600 bg-clip-text text-transparent ${className}`}>
      Futuro Chat
    </span>
  );
}

export default function FuturoChatBrand({ size = "md", testid }) {
  const icon = size === "lg" ? 22 : 16;
  return (
    <span className="inline-flex items-center gap-2" data-testid={testid}>
      <FuturoChatIcon size={icon} />
      <FuturoChatWordmark className={size === "lg" ? "text-xl" : "text-sm"} />
    </span>
  );
}
